export default __webpack_public_path__ + "static/media/logo9.75361ba8.png";